type Handler = () => void;

let unauthorizedHandler: Handler | null = null;

export const setUnauthorizedHandler = (handler: Handler | null) => {
  unauthorizedHandler = handler;
};

export const handleUnauthorized = () => {
  if (unauthorizedHandler) {
    try {
      unauthorizedHandler();
      return;
    } catch {
      // fallthrough to default
    }
  }
  if (typeof window !== 'undefined') {
    window.location.href = '/login';
  }
};
